// @flow
import { PaddedAndRaisedSegment } from '@presentational/PaddedAndRaisedSegment';
import { PrimaryButton } from '@presentational/buttons/PrimaryButton';
import { NegativeMessageContainer } from '@presentational/messages/NegativeMessageContainer';
import { StyledHeader } from '@src/common-utils/styledComponents';
import React from 'react';
import { useParams } from 'react-router-dom';
import { SP_PRICING_STATUS_STATES } from '@src/constants';

const SPAsyncCalcContainer = ({
  data,
  children,
  useRecalcRequestMutation,
  disabled = false,
  reloadAfterReclacRequest = false,
}) => {
  const params = useParams();

  const [submitRecalcRequest] = useRecalcRequestMutation();
  const status = data.status;

  if (status === SP_PRICING_STATUS_STATES.FAILED) {
    return (
      <PaddedAndRaisedSegment disabled={disabled}>
        <PrimaryButton
          onClick={async () => {
            await submitRecalcRequest({ ...params });
            if (reloadAfterReclacRequest) {
              window.location.reload();
            }
          }}
          text="Re-Calculate Now!"
        />
        <NegativeMessageContainer
          body={
            <p>
              Please try again by clicking the button above. If it persists, please contact
              #cloud-commitment-estimator channel
            </p>
          }
          header="An Unexpected Error Occurred"
        />
      </PaddedAndRaisedSegment>
    );
  }

  if (status === SP_PRICING_STATUS_STATES.PENDING) {
    return (
      <PaddedAndRaisedSegment disabled={disabled}>
        <PrimaryButton
          onClick={async () => {
            await submitRecalcRequest({ ...params });
            if (reloadAfterReclacRequest) {
              window.location.reload();
            }
          }}
          text="Re-Calculate Now!"
        />
        <StyledHeader style={{ color: 'red' }}>
          You have made some edits! Please click on Re-Calculate Now to fetch latest data!
        </StyledHeader>
      </PaddedAndRaisedSegment>
    );
  }

  if (
    status === SP_PRICING_STATUS_STATES.IN_PROGRESS ||
    status === SP_PRICING_STATUS_STATES.QUEUED
  ) {
    return (
      <PaddedAndRaisedSegment disabled={disabled}>
        <PrimaryButton disabled={true} text="Re-Calculate Now!" />
        <StyledHeader style={{ color: 'red' }}>
          Note: Repricing is still happening! Please wait while the reprice finishes. You can
          refresh the page periodically to get the latest status.
        </StyledHeader>
      </PaddedAndRaisedSegment>
    );
  }

  if (status === SP_PRICING_STATUS_STATES.SUCCESS) {
    return children;
  }
};

export default SPAsyncCalcContainer;
